import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'

import * as firebase from 'firebase'
import { connect } from 'react-redux'
import moment from 'moment'
import MenuItem from 'material-ui/MenuItem'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'

class AddJobController extends React.Component {

  static propTypes = {
    eventTemplates: PropTypes.array.isRequired,
    addJobInfo: PropTypes.object,
    teamId: PropTypes.string.isRequired
  }
  
  constructor(props) {
    super(props)
    this.state = {
      openSelectTemplate: undefined
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.addJobInfo && this.props.addJobInfo !== nextProps.addJobInfo) {
      if (!nextProps.addJobInfo.clone) {
        this.addJob(nextProps.addJobInfo)
      } else {
        this.addJobFromTemplate({ modules: nextProps.addJobInfo.modules }, { dateStr: nextProps.addJobInfo.dateStr }, true)
      }
    }
  }

  addJob(newJobInfo) {
    newJobInfo.anchorButton = ReactDOM.findDOMNode(newJobInfo.anchorButton)
    // If only one template, then use it
    if (this.props.eventTemplates.length === 1) {
      this.addJobFromTemplate(this.props.eventTemplates[0], newJobInfo)
      return
    }
    //If more than one template then ask user which template to user
    this.setState({
      openSelectTemplate: newJobInfo
    })
  }

  addJobFromTemplate(template, newJobInfo, isClone) {
    // Save the whole new job in firebase starting with a copy of the template
    const jobInfo = {
      creatorId: firebase.auth().currentUser.uid,
      teamId: this.props.teamId,
      temporal: true,
      modules: JSON.parse(JSON.stringify(template.modules))
    }

    // Set the date
    if (newJobInfo.dateStr) {
      jobInfo.modules.date.startDate = newJobInfo.dateStr
      jobInfo.modules.date.endDate = newJobInfo.dateStr

      if (jobInfo.modules.date.recurrence) {
        jobInfo.modules.date.endDate = '2019-12-31'
        jobInfo.modules.date.recurrence.startDate = newJobInfo.dateStr

        if (!isClone) {
          jobInfo.modules.date.recurrence.repeatOn = {}
          jobInfo.modules.date.recurrence
            .repeatOn[moment(newJobInfo.dateStr).isoWeekday()] = true
        }
      }
    }

    // Set the worker
    if (newJobInfo.workerId) {
      jobInfo.modules.workers.list = {}
      jobInfo.modules.workers.list[newJobInfo.workerId] = { id: newJobInfo.workerId }
    }

    this.props.dispatch({
      type: 'UI_DIALOG',
      label: 'JOB_SCREEN',
      value: {
        jobInfo: jobInfo,
        dateStr: moment().format('YYYY-MM-DD')
      }
    })
  }

  handleTemplateSelection(isBatchOption, templateIndex) {
    const selectedTemplate = this.props.eventTemplates[templateIndex]
    if(isBatchOption) {
      delete selectedTemplate.modules.displayName
      selectedTemplate.modules.batchName = {
        value: ''
      }
    }
    this.addJobFromTemplate(selectedTemplate, this.state.openSelectTemplate)
    this.setState({
      openSelectTemplate: undefined
    })
  }

  renderTemplatesOptions() {
    const views = []
    for (let i = 0; i < this.props.eventTemplates.length; i++) {
      const templateName = this.props.eventTemplates[i].displayName
      views.push(
        <MenuItem
          key={i}
          onTouchTap={() => this.handleTemplateSelection(false, i)}
          primaryText={templateName}/>
      )
    }
    return views
  }

  render() {
    const anchorButton = this.state.openSelectTemplate !== undefined
      ? this.state.openSelectTemplate.anchorButton
      : null
    return (
      <Popover
        open={this.state.openSelectTemplate !== undefined}
        anchorEl={anchorButton}
        anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
        targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
        onRequestClose={() => this.setState({openSelectTemplate: undefined})}>
        <Menu>
          {this.renderTemplatesOptions()}
        </Menu>
      </Popover>)
  }
}

const mapStateToProps = state => {
  const eventTemplates = state.firebase.team['templates/events']
  return {
    teamId: state.firebase.team.metadata.value.id,
    addJobInfo: state.uiDialogs['ADD_JOB'],
    eventTemplates: !eventTemplates || eventTemplates.loading ? [] : eventTemplates.value
  }
}

export default connect(mapStateToProps)(AddJobController)



// WEBPACK FOOTER //
// ./src/schedule/common/AddJobController.js